import React, { useState, useEffect, useCallback } from 'react';
import { Bell, BellOff } from 'lucide-react';
import { registerPushSubscription, unregisterPushSubscription, isPushSubscribed, isPushSupported } from '../../../utils/pushNotifications';

function PushToggle() {
  var supported = isPushSupported();
  var [subscribed, setSubscribed] = useState(false);
  var [loading, setLoading] = useState(false);

  useEffect(function () {
    if (supported) {
      isPushSubscribed().then(function (s) { setSubscribed(s); });
    }
  }, [supported]);

  var handleToggle = useCallback(async function () {
    if (loading) return;
    setLoading(true);
    try {
      if (subscribed) {
        await unregisterPushSubscription();
        setSubscribed(false);
      } else {
        var sub = await registerPushSubscription();
        setSubscribed(!!sub);
      }
    } catch (e) {
      console.error('Push toggle error:', e);
    }
    setLoading(false);
  }, [subscribed, loading]);

  if (!supported) return null;

  return React.createElement('button', {
    onClick: handleToggle,
    disabled: loading,
    className: 'p-2 rounded-lg transition-colors ' + (
      subscribed
        ? 'text-emerald-400 hover:bg-emerald-500/10'
        : 'text-slate-500 hover:bg-slate-700 hover:text-slate-300'
    ),
    title: subscribed ? 'Push alerts ON — click to disable' : 'Enable push alerts',
    'data-testid': 'push-toggle'
  }, subscribed
    ? React.createElement(Bell, { className: 'w-5 h-5' })
    : React.createElement(BellOff, { className: 'w-5 h-5' })
  );
}

export default PushToggle;
